export default __webpack_public_path__ + "static/media/toomanytocount.4951bd72.png";